import Vue from 'vue'
import VueshortKey from 'vue-shortkey'

Vue.use(VueshortKey)
